(() => {
  const openDialog = (trigger) => {
    const dialog = document.getElementById(trigger.dataset.dialogId);
    if (!dialog || !dialog.showModal) return;

    const frame = dialog.querySelector('[data-sn-video-frame]');
    const videoId = dialog.dataset.videoId;
    if (frame && videoId) {
      frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
    }
    dialog.showModal();
  };

  const closeDialog = (dialog) => {
    const frame = dialog.querySelector('[data-sn-video-frame]');
    if (frame) frame.src = '';
    dialog.close();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sn-video-modal-trigger]');
    if (trigger) {
      openDialog(trigger);
      return;
    }

    const close = event.target.closest('[data-sn-video-modal-close]');
    if (close) {
      closeDialog(close.closest('[data-sn-video-dialog]'));
      return;
    }

    const dialog = event.target.closest('[data-sn-video-dialog]');
    if (dialog && event.target === dialog) closeDialog(dialog);
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('[data-sn-video-dialog]')) return;
    const frame = event.target.querySelector('[data-sn-video-frame]');
    if (frame) frame.src = '';
  }, true);
})();
